import { equals } from "ramda";
import { type RefObject, useEffect, useState } from "react";

/**
 * Pass all data-* attributes
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useDataAttributes = (props: any): Record<string, string> => {
  const [data, setData] = useState({});

  useEffect(() => {
    const dataAttributes: Record<string, string> = {};

    for (const key of Object.keys(props)) {
      if (key.startsWith("data-")) {
        const value = props[key];
        if (value != undefined) dataAttributes[key] = props[key];
      }
    }

    if (!equals(data, dataAttributes)) {
      setData(dataAttributes);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  return data;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useSetDataAttributesToRef = (props: any, ref: RefObject<HTMLElement>): void => {
  const dataAttributes = useDataAttributes(props);

  useEffect(() => {
    if (ref.current) {
      for (const [key, value] of Object.entries<string>(dataAttributes)) {
        ref.current.dataset[key.slice(5)] = value;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataAttributes]);
};
